import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as _ from 'lodash';
import {catchError, map, switchMap} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {externalLinksActionTypes, LoadExternalLinksAction, LoadExternalLinksFailAction, LoadExternalLinksSuccessAction} from '../actions/external-links';
import {error} from '../actions/toasts';
import {ArrayResponse} from '../models/array-response';
import {ExternalLink} from '../models/external-link';
import {SendBackResult} from '../models/send-back-result';
import {ExternalLinksService} from '../services/external-links.service';
import {BaseEffect} from './base.effect';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class ExternalLinksEffect extends BaseEffect {

  load$ = createEffect(() => { return this.actions$.pipe(ofType(externalLinksActionTypes.LOAD),
       debug('External Links load action received.'))
      .pipe(switchMap((action: LoadExternalLinksAction) =>
                        this.externalLinksService.getList(action.payload)
                          .pipe(
                            map((result: SendBackResult<ArrayResponse<ExternalLink>>) => _.uniqBy(_.filter(result.data.array, x => x.url != undefined), 'url')),
                            map((links: ExternalLink[]) => new LoadExternalLinksSuccessAction(links)),
                            catchError(res => this.catchResponseError(res)),
                            )))
  });

  loadFail$ = createEffect(() => { return this.actions$
                .pipe(ofType(externalLinksActionTypes.LOAD_FAIL),
                      debug('A server error occurred while retrieving group roles list.'),
                      map((action: LoadExternalLinksFailAction) =>
                        error(this.translation.translate('GROUP_ROLES_LOAD_ERROR') + '  ' + action.payload,
                          this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions, private translation: L10nTranslationService, private externalLinksService: ExternalLinksService, router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => new LoadExternalLinksFailAction(response['error'].message)

  protected handleGoneError = (response) => {
    return new LoadExternalLinksFailAction(response['error'].message);
  }
}
